import { render, staticRenderFns } from "./leavingMessage.vue?vue&type=template&id=56ef450b&scoped=true&"
import script from "./leavingMessage.vue?vue&type=script&lang=js&"
export * from "./leavingMessage.vue?vue&type=script&lang=js&"
import style0 from "./leavingMessage.vue?vue&type=style&index=0&id=56ef450b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef450b",
  null
  
)

export default component.exports